import '../scss/home-blog-style.scss';
import HomeBlog from './pages/blog/home/index';

document.addEventListener('DOMContentLoaded', () => {
  HomeBlog.init();
});
